export default {
  translation: {
    common: {
      emailOrUsername: 'Email o username',
      invalidUsernameOrPassword: 'Username o password non valido',
      logInToBoards: 'Log in',
      noInternetConnection: 'Nessuna connessione internet',
      pageNotFound_title: 'Pagina non trovata',
      password: 'Password',
      serverConnectionFailed: 'Connesione al server fallita',
      unknownError: 'Errore sconosciuto, prova ancora',
    },

    action: {
      logIn: 'Log in',
    },
  },
};
